import { Container, Stack, Title } from '@mantine/core'
import { SettingsPanel } from '../components/common/SettingsPanel'

export default function Settings() {
  return (
    <Container size="sm" py="xl">
      <Stack gap="lg">
        <Title order={2} ff="var(--bw-heading-font)" c="cyan.4">
          Settings
        </Title>
        <SettingsPanel />
      </Stack>
    </Container>
  )
}
